import http from "../http";
import ApiConstants from '../constants/ApiConstants';

class BankAccountService {
    static BANK_ACCOUNT = null;

    static getBankAccounts(accountType) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.BANK_ACCOUNT.GET_BANK_ACCOUNTS}`;
        const params = {
            accountType: accountType
        };

        return http.get(URL, { params: params }).catch(
            (error) => {
                console.error('Error fetching bank accounts: ', error);
                return Promise.reject(error);
            }
        );
    }

    static getGIROBankDetails(countryCode) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.BANK_ACCOUNT.GET_BANK_DETAILS}`;
        const params = {
            GIRO: true,
            countryCode: countryCode
        };

        return http.get(URL, { params: params }).catch(
            (error) => {
                console.error('Error fetching bank accounts: ', error);
                return Promise.reject(error);
            }
        );
    }

    static saveBankAccount(payload) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.BANK_ACCOUNT.SAVE_BANK_ACCOUNT}`;
        return http.post(URL, payload).catch(
            (error) => {
                console.error('Error saving bank accounts: ', error);
                return Promise.reject(error);
            }
        );
    }

    static updateBankAccount(id, payload) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.BANK_ACCOUNT.SAVE_BANK_ACCOUNT}/${id}`;
        return http.put(URL, payload).catch(
            (error) => {
                console.error('Error updating bank accounts: ', error);
                return Promise.reject(error);
            }
        );
    }

    static deleteBankAccount(id) {
        const URL = `${ApiConstants.URL.BASE}${ApiConstants.URL.BANK_ACCOUNT.SAVE_BANK_ACCOUNT}/${id}`;
        return http.delete(URL).catch(
            (error) => {
                console.error('Error deleting bank accounts: ', error);
                return Promise.reject(error);
            }
        );
    }
}

export default BankAccountService;